import { IEnumeration } from 'utility-js-enumeration';

declare var Enumeration: IEnumeration;

const DaysOfTheWeekEnum = {
  sunday: {
    serverValue: 1,
    scheduleValue: 'Sun'
  },
  monday: {
    serverValue: 2,
    scheduleValue: 'Mon'
  },
  tuesday: {
    serverValue: 3,
    scheduleValue: 'Tue'
  },
  wednesday: {
    serverValue: 4,
    scheduleValue: 'Wed'
  },
  thursday: {
    serverValue: 5,
    scheduleValue: 'Thu'
  },
  friday: {
    serverValue: 6,
    scheduleValue: 'Fri'
  },
  saturday: {
    serverValue: 7,
    scheduleValue: 'Sat'
  },
  nonCampus: {
    serverValue: 8,
    scheduleValue: 'non-campus'
  }
};

angular
  .module('capability-ng-course-schedule')
  .constant('daysOfTheWeekEnum', Enumeration('DaysOfTheWeekEnum', DaysOfTheWeekEnum));



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-course-schedule/src/types/days_of_week.ts